import config from '@/config/index';
import { LogicContext } from '@/logic/main/types';
import {
  divideGameListToSlides,
  mapGamesWithJackpotsV2,
} from '@/logic/main/utils';
import { RECENTLY_PLAYED_CATEGORY_ID } from '@/model/constants';

export const fetchRecentlyPlayedContent = async (context: LogicContext) => {
  const { user, controllersData, rpFirstLoad = true } = context;
  const gameDetailsInfo = config.features.gameDetails.mode === 'enabled';

  if (!user || !controllersData || !controllersData.recentlyPlayed) {
    return {
      updates: [],
    };
  }

  const { recentlyPlayedGamesList = [] } = user;
  const { components } = controllersData.recentlyPlayed;

  const rpVisible =
    user.loggedIn &&
    recentlyPlayedGamesList.length > 0 &&
    !context.isGameModalForMobileOpened;
  const rpGamesWithJackpot = mapGamesWithJackpotsV2(
    recentlyPlayedGamesList,
    context.currentJackpotsV2
  );

  const updates = components.map(([id, cmp]) => {
    const {
      view_all_button,
      view_all_button_visible,
      title,
      description,
      type,
      staticTexts,
      game_number_limit,
    } = cmp.properties;

    const rpCategory = {
      id: RECENTLY_PLAYED_CATEGORY_ID,
      description,
      view_all_button,
      view_all_button_visible,
      title,
      games: rpGamesWithJackpot,
      gameDetailsInfo,
      staticTexts,
      type,
      ...(type === 'Grid'
        ? {
            component_type: 'game_collection',
            slides: [
              {
                gameList: rpGamesWithJackpot,
                type: 'Collection',
                gamesLimit: game_number_limit ? game_number_limit : 6,
              },
            ],
          }
        : {
            component_type: 'game_grid',
            slides: divideGameListToSlides({
              gameList: rpGamesWithJackpot,
              slideType: type,
            }),
          }),
    };

    return {
      type: 'setLayoutProperty',
      data: {
        path: `components.${id}.properties`,
        value: {
          category: rpVisible ? rpCategory : undefined,
          animation: rpFirstLoad,
          visible: rpVisible,
        },
      },
    };
  });

  return {
    updates,
  };
};
